module.exports = __webpack_public_path__ + "static/banner-316cc0f77e5b628de4db2adeb6e0ba25.png";